import { useQuery } from '@tanstack/react-query';
import PageTitle from 'apps/home/components/PageTitle';
import apiCall from 'apps/robo-advisory/apiCalls/portfolio';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { ListPage } from 'common/ui/admin-CRUD/page';
import { useParams } from 'react-router-dom';

import { columnsGenerator } from './config';
import ItemDetail from './detail';
import { FilterForm } from './filter-form';
export { PortfolioAnalysisPage } from './analysis';
export { PortfolioTargetPage } from './target';

export const PortfolioListPage = (props, { params }) => (
  <ListPage
    title="All Customer's Portfolios"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={FilterForm}
  />
);

export const PortfolioDetailPage = props => {
  const { user_id } = useParams();

  const { data: response, isLoading, error: fetchItemError } = useQuery({
    queryKey: [apiCall.detail.queryKey, user_id],
    queryFn: () => apiCall.detail.queryFn({ user_id }),
  });

  // Handle response - it might be an array when filtered by user_id
  const item = Array.isArray(response?.data)
    ? response.data[0]
    : response?.data || response;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (fetchItemError) {
    return <ErrorMessage {...fetchItemError} />;
  }

  if (!item) {
    return (
      <ErrorMessage errors={{ message: 'Portfolio not found for this user' }} />
    );
  }

  return (
    <>
      <PageTitle title="View Portfolio" backUrl="/robo-advisory/portfolios" />
      <ItemDetail item={item} apiCall={apiCall} />
    </>
  );
};
